module.exports = __webpack_public_path__ + "img/signature-white.324920a2.svg";